/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_XsInputs */

const en_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const es_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const fr_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const de_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const ja_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const zh_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const ar_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صغير جداً (XS)`)
};

const id_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const it_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const ru_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

const pt_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PP (XS)`)
};

const ko_val_xs = /** @type {(inputs: Val_XsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XS`)
};

/**
* | output |
* | --- |
* | "XS" |
*
* @param {Val_XsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_xs = /** @type {((inputs?: Val_XsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_XsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_xs(inputs)
	if (locale === "es") return es_val_xs(inputs)
	if (locale === "fr") return fr_val_xs(inputs)
	if (locale === "de") return de_val_xs(inputs)
	if (locale === "ja") return ja_val_xs(inputs)
	if (locale === "zh") return zh_val_xs(inputs)
	if (locale === "ar") return ar_val_xs(inputs)
	if (locale === "id") return id_val_xs(inputs)
	if (locale === "it") return it_val_xs(inputs)
	if (locale === "ru") return ru_val_xs(inputs)
	if (locale === "pt") return pt_val_xs(inputs)
	return ko_val_xs(inputs)
});